var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1269,
    height: 680,
    viewBox: "0 0 1269 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_1583_977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -13.4609C233.836 7.15203 19.2841 204.572 193.033 332.229C352.265 449.219 646.871 216.748 669.736 564.158C685.391 802.011 757.915 893.306 949.764 952.633",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1704 -25.7148C245.006 -5.10188 30.4545 192.318 204.204 319.975C363.435 436.965 658.042 204.494 680.907 551.904C696.561 789.757 769.085 881.052 960.935 940.379",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3403 -37.9727C256.176 -17.3597 41.6244 180.061 215.374 307.717C374.605 424.707 669.212 192.236 692.077 539.646C707.731 777.499 780.255 868.794 972.105 928.121",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5103 -50.2227C267.346 -29.6097 52.7943 167.811 226.544 295.467C385.775 412.457 680.382 179.986 703.247 527.396C718.901 765.249 791.425 856.544 983.275 915.871",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6807 -62.4805C278.517 -41.8675 63.9647 155.553 237.714 283.209C396.946 400.2 691.552 167.728 714.417 515.139C730.072 752.992 802.595 844.286 994.445 903.614",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8511 -74.7305C289.687 -54.1175 75.1351 143.303 248.885 270.959C408.116 387.949 702.722 155.478 725.588 502.888C741.242 740.741 813.766 832.036 1005.62 891.363",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.022 -86.9961C300.858 -66.3831 86.306 131.037 260.055 258.694C419.287 375.684 713.893 143.213 736.758 490.623C752.413 728.476 824.937 819.771 1016.79 879.098",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1919 -99.2461C312.028 -78.6331 97.476 118.787 271.225 246.444C430.457 363.434 725.063 130.963 747.928 478.373C763.583 716.226 836.106 807.521 1027.96 866.848",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3613 -111.496C323.197 -90.8831 108.645 106.537 282.395 234.194C441.626 351.184 736.233 118.713 759.098 466.123C774.752 703.976 847.276 795.271 1039.13 854.598",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.532 -123.75C334.368 -103.137 119.816 94.2832 293.566 221.94C452.797 338.93 747.404 106.459 770.269 453.869C785.923 691.722 858.447 783.017 1050.3 842.344",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.703 -136.012C345.539 -115.399 130.987 82.0215 304.736 209.678C463.968 326.668 758.574 94.197 781.439 441.607C797.094 679.46 869.617 770.755 1061.47 830.082",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.874 -148.262C356.71 -127.649 142.158 69.7715 315.907 197.428C475.139 314.418 769.745 81.9469 792.61 429.357C808.265 667.21 880.788 758.505 1072.64 817.832",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.043 -160.52C367.88 -139.907 153.328 57.5137 327.077 185.17C486.308 302.16 780.915 69.6892 803.78 417.099C819.434 654.953 891.958 746.247 1083.81 805.574",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.213 -172.773C379.049 -152.16 164.497 45.2598 338.246 172.916C497.478 289.907 792.084 57.4352 814.949 404.846C830.604 642.699 903.127 733.993 1094.98 793.321",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.383 -185.031C390.219 -164.418 175.667 33.002 349.417 160.659C508.648 277.649 803.255 45.1774 826.12 392.588C841.774 630.441 914.298 721.735 1106.15 781.063",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.554 -197.277C401.39 -176.664 186.838 20.7559 360.588 148.413C519.819 265.403 814.426 32.9313 837.291 380.342C852.945 618.195 925.469 709.489 1117.32 768.817",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.724 -209.539C412.56 -188.926 198.008 8.49416 371.757 136.151C530.989 253.141 825.595 20.6696 848.46 368.08C864.115 605.933 936.638 697.228 1128.49 756.555",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.896 -221.789C423.732 -201.176 209.18 -3.75584 382.929 123.901C542.16 240.891 836.767 8.41962 859.632 355.83C875.287 593.683 947.81 684.978 1139.66 744.305",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.064 -234.047C434.901 -213.434 220.349 -16.0137 394.098 111.643C553.329 228.633 847.936 -3.83822 870.801 343.572C886.455 581.425 958.979 672.72 1150.83 732.047",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.236 -246.293C446.072 -225.68 231.52 -28.2597 405.269 99.3969C564.501 216.387 859.107 -16.0843 881.972 331.326C897.627 569.179 970.15 660.474 1162 719.801",
    stroke: "#2C6EFC",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1583_977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1269,
    height: 680,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/Lines.2b98cdd95f03c8b6eaaf95416c567425.svg";
export { ForwardRef as ReactComponent };